<template>
    <div class="merchant-routing-rule">
        <div class="merchant-routing-rule__contents">
            <div class="merchant-routing-rule__header">
            <h1>Set Global Collections Account</h1>
            <p>Be sure to enter the right bank account information</p>
            </div>
            <div>
                <div class="space-down">
                <Dropdown title="Collection Bank" label="Select bank" :options="bankList.length > 0 ? bankList : []" :onOptionSelected="({ id }) => state.selected.bank_code = id" />
                </div>
                <div class="space-down">
                    <Input label="Collection Account" :value="state.selected.collection_account" :onChange="value => state.selected.collection_account = value"/>
                </div>
                <div class="space-down submit">
                    <Button  buttonName="Save Collections Account" :onClick="handleSaveCollectionAccount" classes="primary"  :disabled="!state.selected.bank_code.length" />
                </div>
            </div>
        </div>
        <div class="footer"></div>
    </div>
    
</template>
<script>
import Dropdown from "@/components/dropdown"
import Button from "@/components/button.vue"
import Input from "@/components/input.vue"

import { reactive, onBeforeMount, computed, watch } from '@vue/composition-api'

export default {
  components: {
      Dropdown,
      Button,
      Input
  },
    setup(props, { root }) {
        const store = root.$store;

       const bankList = computed(() => store.getters.getBankListKeyAndValuePair);
       const contents = computed(() => store.getters.getDefaultCollectionAccount);

        const state = reactive({
            selected: {
                bank_code: '',
                collection_account: ''
            }
        })

        const getBanksWithRules = banks => banks ? banks.filter(({ rule_applied }) =>  rule_applied === true) : [];

        const handleSaveCollectionAccount = () => {
            store.dispatch('saveCollectionAccount', state.selected)
        }

        return {
            state,
            bankList,
            getBanksWithRules,
            handleSaveCollectionAccount,
            contents
        }

    }
}
</script>
<style lang="scss">
.merchant-routing-rule {
    display: flex;
    flex-direction: column;

    .custom-input {
        input {
            border: none !important;
            max-width: 100% !important;
        }
    }

    &__header {
        h1 {
            /*font-family: 'lato-regular';*/
            font-style: italic;
            font-weight: normal;
            font-size: 18px;
            line-height: 22px;
            color: #261940;
            margin-bottom: 14px;
        }

        p {
            /*font-family: 'lato-regular';*/
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 24px;
            color: #261940;
            opacity: 0.7;
            width: 267px;
        }
    }

    &__contents {
        display: flex;
        justify-content: space-between;
       padding: 0 130px 58px 130px;
    }

    .submit {
        .btn {
            height: 51px;
            justify-content: center;

            .btn--text {
                /*font-family: 'lato-regular';*/
                font-style: normal;
                font-weight: 500;
                font-size: 15px !important;
                line-height: 26px;
                text-align: center;
            }
        }
    }

    .space-down {
        margin-bottom: 32px;
    }

    .drop-down, .btn {
        width: 386px;
    }

    .dropdown-options {
       width: 386px;
    }

    .footer {
        height: 86px;
        border-top: 1px solid #EBF0F4;
    }
}
</style>